module.exports = __webpack_public_path__ + "static/media/rating-hub-logo.34366dbb.svg";